import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { ResponseJson } from '../models/model';
import { environment } from '../../../environments/environment.dev';

export enum WEBSITE_TYPE {
    ARENA = 'ARENA',
    AI = 'AI'
}

export interface IContactUs extends Document {
    typeOfWebsite: WEBSITE_TYPE;
    company: string;
    message: string;
    createdAt: Date
}

@Injectable({ providedIn: 'root' })
export class ProspectService extends BaseService {
    private apiUrl = environment.prospectUrl;

    contactUs(formData: any): Observable<ResponseJson<IContactUs[]>> {
        return this.post(`${this.apiUrl}/contact-us/create`, formData);
    }
}
